import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [theme, setTheme] = useState(localStorage.getItem('app-theme') || 'dark');

  const toggleTheme = () => {
    const newTheme = theme === 'dark' ? 'light' : 'dark';
    setTheme(newTheme);
    localStorage.setItem('app-theme', newTheme);
    document.body.setAttribute('data-theme', newTheme);
  };
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [mensaje, setMensaje] = useState(null);
  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const apiBase = isLocal ? `http://${window.location.hostname}:3010` : `${window.location.protocol}//${window.location.hostname}`;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      return setError('Las contraseñas no coinciden. Inténtalo de nuevo.');
    }
    if (newPassword.length < 6) {
      return setError('Por seguridad, la contraseña debe tener al menos 6 caracteres.');
    }

    setIsSubmitting(true);
    setError(null);
    setMensaje(null);

    try {
      const resp = await fetch(`${apiBase}/api/reset-password`, { credentials: 'include', 
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, newPassword })
      });
      const data = await resp.json();
      
      if (resp.ok) {
        setMensaje(data.message || 'Contraseña actualizada correctamente.');
        setTimeout(() => navigate('/'), 3000);
      } else {
        setError(data.error || 'El enlace es inválido o ha expirado.');
      }
    } catch(err) {
      setError('Fallo de conexión con el servidor municipal.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--bg-main)',
      backgroundImage: `
        radial-gradient(circle at 10% 20%, rgba(99, 102, 241, 0.05) 0%, transparent 40%),
        radial-gradient(circle at 90% 80%, rgba(14, 165, 233, 0.05) 0%, transparent 40%)
      `,
      fontFamily: "var(--font-main)",
      padding: '24px',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Universal Theme Toggle */}
      <button 
        onClick={toggleTheme}
        className="theme-toggle-floating"
        title={theme === 'dark' ? "Cambiar a Modo Claro" : "Cambiar a Modo Oscuro"}
        style={{
          position: 'fixed',
          top: '30px',
          right: '30px',
          background: 'var(--card-bg)',
          backdropFilter: 'blur(12px)',
          border: '1px solid var(--glass-border)',
          color: theme === 'dark' ? 'var(--p-amber)' : 'var(--p-indigo)',
          width: '45px',
          height: '45px',
          borderRadius: '14px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
          zIndex: 1000,
          boxShadow: 'var(--shadow-lg)'
        }}
        onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.1) rotate(15deg)'; }}
        onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1) rotate(0deg)'; }}
      >
        <i className={theme === 'dark' ? 'fa-solid fa-sun' : 'fa-solid fa-moon'}></i>
      </button>
      {/* Decorative Background Elements */}
      <div className="bg-blob blob-1" style={{ position: 'absolute', top: '-100px', right: '-100px', width: '500px', height: '500px', background: 'linear-gradient(135deg, rgba(99, 102, 241, 0.2), rgba(14, 165, 233, 0.2))', borderRadius: '50%', filter: 'blur(80px)', zIndex: 0 }}></div>
      <div className="bg-blob blob-2" style={{ position: 'absolute', bottom: '-150px', left: '-150px', width: '500px', height: '500px', background: 'linear-gradient(135deg, rgba(99, 102, 241, 0.2), rgba(14, 165, 233, 0.2))', borderRadius: '50%', filter: 'blur(80px)', zIndex: 0 }}></div>

      <div className="animate-fade-in" style={{
        background: 'var(--card-bg)',
        backdropFilter: 'blur(24px)',
        WebkitBackdropFilter: 'blur(24px)',
        border: '1px solid var(--glass-border)',
        borderRadius: 'var(--radius-xl)',
        padding: '48px 40px',
        width: '100%',
        maxWidth: '440px',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.1)',
        textAlign: 'center',
        position: 'relative',
        zIndex: 10
      }}>
        <div style={{ marginBottom: '32px' }}>
          <div style={{
            width: '80px',
            height: '80px',
            background: 'var(--sidebar-accent)',
            borderRadius: '24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px',
            border: '1px solid var(--glass-border)',
            boxShadow: '0 8px 16px rgba(0,0,0,0.1)'
          }}>
            <i className="fa-solid fa-key" style={{ fontSize: '32px', color: 'var(--p-indigo)' }}></i>
          </div>
          <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: '32px', color: 'var(--p-navy)', margin: '0 0 8px 0', letterSpacing: '-0.04em', fontWeight: 800 }}>Restablecer Clave</h2>
        </div>

        {error && (
          <div className="animate-fade-in" style={{ background: 'rgba(244, 63, 94, 0.1)', color: 'var(--p-rose)', border: '1px solid rgba(244, 63, 94, 0.2)', padding: '12px', borderRadius: '12px', marginBottom: '20px', fontSize: '13px', textAlign: 'center', fontWeight: '600' }}>
            <i className="fa-solid fa-circle-exclamation"></i> {error}
          </div>
        )}

        {mensaje && (
          <div className="animate-fade-in" style={{ background: 'rgba(16, 185, 129, 0.1)', color: 'var(--p-emerald)', border: '1px solid rgba(16, 185, 129, 0.2)', padding: '12px', borderRadius: '12px', marginBottom: '20px', fontSize: '13px', textAlign: 'center', fontWeight: '600' }}>
            <i className="fa-solid fa-circle-check"></i> {mensaje}
          </div>
        )}

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <div className="input-group" style={{ textAlign: 'left', display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <label style={{ fontSize: '11px', fontWeight: 800, color: 'var(--p-slate)', textTransform: 'uppercase', letterSpacing: '0.1em', paddingLeft: '4px' }}>Nueva Contraseña</label>
            <div style={{ position: 'relative' }}>
              <i className="fa-solid fa-lock" style={{ position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)', color: 'var(--p-slate)' }}></i>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="••••••••"
                style={{ padding: '14px 16px 14px 45px', background: 'var(--input-bg)', border: '1px solid var(--glass-border)', color: 'var(--p-navy)', borderRadius: '8px', width: '100%', fontSize: '15px' }}
                required
              />
            </div>
          </div>

          <div className="input-group" style={{ textAlign: 'left', display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <label style={{ fontSize: '11px', fontWeight: 800, color: 'var(--p-slate)', textTransform: 'uppercase', letterSpacing: '0.1em', paddingLeft: '4px' }}>Confirmar Contraseña</label>
            <div style={{ position: 'relative' }}>
              <i className="fa-solid fa-shield-check" style={{ position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)', color: 'var(--p-slate)' }}></i>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="••••••••"
                style={{ padding: '14px 16px 14px 45px', background: 'var(--input-bg)', border: '1px solid var(--glass-border)', color: 'var(--p-navy)', borderRadius: '8px', width: '100%', fontSize: '15px' }}
                required
              />
            </div>
          </div>

          <button 
            type="submit" 
            className="login-button"
            disabled={isSubmitting || !!mensaje}
            style={{ width: '100%', marginTop: '10px' }}
          >
            {isSubmitting ? <span className="spinner"></span> : (mensaje ? '¡Actualizado!' : 'Guardar Nueva Clave')}
          </button>
        </form>

        <div style={{ marginTop: '40px', paddingTop: '24px', borderTop: '1px solid var(--glass-border)' }}>
           <span style={{ fontSize: '10px', color: 'var(--p-slate)', fontWeight: '800', letterSpacing: '0.1em', textTransform: 'uppercase' }}>
             PROPIEDAD INSTITUCIONAL • PITRUFQUÉN
           </span>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;

